export const aboutUs = ['О проекте', 'Контакты', 'Помощь'];

export const apps = {
  iPhone: 'iPhone',
  android: 'Android'
};
